// Function to display a success message when the URL is copied
function showCopySuccessMessage() {
    if ($('.copy-to-clipboard-message').length === 0) {
        $('body').append('<div class="copy-to-clipboard-message"></div>');
    }

    $('.copy-to-clipboard-message').append(
        '<div class="alert alert-success copy-to-clipboard-alert text-center" role="alert">Link copied to clipboard</div>'
    );

    setTimeout(function () {
        $('.copy-to-clipboard-alert').remove();
    }, 5000);
}

// Function to copy the URL using the Clipboard API or execCommand
function copyToClipboard($button, url) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
            showCopySuccessMessage();

            if ($button.data('customer')) {
                var gtmCustomerNumber = $button.data('customer');
                $('body').trigger('gtm:shareBasket', { customerNumber: gtmCustomerNumber });
            }
        }).catch(function (err) {
            console.error('Failed to copy:', err);
            copyToClipboardFallback(url);
        });
    } else {
        // Fallback for older browsers that do not support the Clipboard API
        var $tempInput = $('<input>');
        $tempInput.val(url);
        $('body').append($tempInput);
        $tempInput.select();
        $tempInput[0].setSelectionRange(0, 99999); // For mobile devices

        try {
            var successful = document.execCommand('copy');
            if (successful) {
                showCopySuccessMessage();

                if ($button.data('customer')) {
                    var gtmCustomerNumber = $button.data('customer');
                    $('body').trigger('gtm:shareBasket', { customerNumber: gtmCustomerNumber });
                }
            } else {
                console.error('Failed to copy the link. Please try again.');
            }
        } catch (err) {
            console.error('Failed to copy:', err);
        }

        $tempInput.remove();
    }
}

//Fallback function if the browser doesn't allow access to clipboard
function copyToClipboardFallback(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";  // avoid scrolling to bottom
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
        document.execCommand('copy');
        console.log("Copied using fallback!");
        showCopySuccessMessage();
    } catch (err) {
        console.error('Fallback copy failed:', err);
    }
    document.body.removeChild(textarea);
}

function tryAgainMessage() {
    if ($('.copy-to-clipboard-message').length === 0) {
        $('body').append('<div class="copy-to-clipboard-message"></div>');
    }

    $('.copy-to-clipboard-message').append(
        '<div class="alert alert-danger copy-to-clipboard-alert text-center" role="alert">Please try again</div>'
    );

    setTimeout(function () {
        $('.copy-to-clipboard-alert').remove();
    }, 5000);
}

module.exports = {
    showCopySuccessMessage: showCopySuccessMessage,
    copyToClipboard: copyToClipboard,
    copyToClipboardFallback: copyToClipboardFallback,
    tryAgainMessage: tryAgainMessage
};